import { IRouterOption } from 'src/router'
import { ShareWithToken } from './components/with-token'
import { EShareRoutes } from './routes.enum'

export const ShareRoutes: IRouterOption[] = [
  {
    path: '/share/:sharingToken',
    component: ShareWithToken,
    name: EShareRoutes.SHARE,
    exact: true,
    meta: {
      requireAuth: false
    }
  }
]
